{
    "faq": {
        "title": "FAQ",
        "faqs": [
          {
            "question": "Can I use MAJORITY if I’m not a migrant?",
            "answer": "Yes! Everyone is welcome. If any of the features in our app interest you, sign up and give it a try."
          },
          {
            "question": "Is MAJORITY a bank?",
            "answer": "We are a financial membership app providing banking services through our partner, Axiom Bank, N.A., Member FDIC. The signature MAJORITY Visa® debit card is also issued by Axiom Bank pursuant to a license from Visa U.S.A. Inc. The card can be used anywhere Visa is accepted!"
          },
          {
            "question": "What is MAJORITY?",
            "answer": "MAJORITY is the first-ever financial membership built by migrants, for migrants. After signing up, you get an FDIC-insured account with no overdraft fees, a Visa® Debit Card, fee-free money transfers, free and low-cost international calls, and more!"
          },
          {
            "question": "Where is MAJORITY?",
            "answer": "We have offices in Houston, Miami, and Stockholm, Sweden. Visit us at MAJORITY Meetup Houston, located in 9801 V Bissonnet Street, Houston, Texas 77036, United States."
          },
          {
            "question": "Will my money be safe with MAJORITY?",
            "answer": "Absolutely. Your MAJORITY account is FDIC-insured, so whether you are in the US or abroad, the money in your account is protected up to $250,000 by the FDIC. Plus, you’ll be able to access your app anywhere, so there’s nothing to worry about."
          }
        ]
      }
}